import { useEffect } from 'react';
import Header from '../../widgets/Header';
import TermsContent from '../../widgets/TermsContent';
import { useBrandConfig } from '../../../context/BrandConfigContext';

const TermsAndConditions = () => {
  const brand = useBrandConfig();

  const hasContent = brand?.terms_content?.length > 0;
  const externalUrl = brand?.legal?.termsUrl;
  const isExternalUrl = externalUrl && externalUrl.startsWith('http');

  useEffect(() => {
    if (!hasContent && isExternalUrl) {
      window.location.replace(externalUrl);
    }
  }, [hasContent, isExternalUrl, externalUrl]);

  if (!hasContent && isExternalUrl) return null;

  return (
    <>
      <Header title="Terms & Conditions" rightContent={' '} />
      <main className="page-content strict-width x-space-top">
        <TermsContent
          items={hasContent ? brand.terms_content : undefined}
          heading={'TERMS AND CONDITIONS GOVERNING PARTICIPATION IN THE "COCA-COLA PREMIER LEAGUE DRINK, SCAN, FIND AND WIN PROMOTION" (The "Promotion")'}
        />
      </main>
    </>
  );
};

export default TermsAndConditions;
